import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-libroriesgos',
  templateUrl: './libroriesgos.component.html',
  styleUrls: ['./libroriesgos.component.css']
})
export class LibroriesgosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
